<template>
  <div>
    <div class="filter-wrap">
      <v-select
        v-model="currentStatusFilter"
        class="filter"
        :items="dropdownItems"
        color="accent"
        label="Статусы"
        item-title="title"
      >
        <template #selection="{ item }">
          {{ item.title }}
        </template>
        <template #item="{ item }">
          {{ item.title }}
        </template>
      </v-select>
    </div>

    <v-text-field
      v-model="search"
      class="search-input"
      append-icon="search"
      color="accent"
      label="Номер кошелька"
      single-line
      hide-details
    />

    <v-text-field
      v-model="transactionId"
      color="accent"
      class="search-input"
      append-icon="search"
      label="Id операции"
      single-line
      hide-details
    />

    <v-text-field
      v-model="outerTransactionId"
      class="search-input"
      append-icon="search"
      color="accent"
      label="Внешний id операции"
      single-line
      hide-details
    />

    <br>

    <div v-if="selected.length !== 0" style="display: flex; gap: 15px; align-items: center">
      <p style="margin: 0">Выбрано ({{ selectedPaymentMethod }}): {{ selected.length }} ({{ totalAmount() }})</p>
      <v-icon
        class="icon"
        small
        @click="selectModal"
      >
        currency_exchange
      </v-icon>
      <v-icon style="cursor: pointer" small @click="confirm(2)">fas fa-check</v-icon>
      <v-icon style="cursor: pointer" small @click="confirm(1)">fas fa-times</v-icon>
    </div>

    <paginated-table
      ref="table"
      :items="items"
      :headers="headers"
      :loading="loading"
      :pagination.sync="pagination"
      :pullFunction="pullFunction"
    >
      <template #items="props">
        <PaymentItem
          :item="props.item"
          :changeSelect="switchBox"
          :paymentMethod="selectedPaymentMethod"
          @item-selected="handleItemSelected"
          @refresh-table="pullFunction(page)"
          @copied="wasCopied = true"
          @clear="selectedPaymentMethod = null,selected = []"
        />
      </template>
    </paginated-table>

    <PayoutsMethodsModal
      :snackbar="snackbar"
      :is-disabled="isDisabled"
      :snackbar-text="snackbarText"
      :confirmation-dialog="confirmationDialog"
      :payment-dialog="paymentDialog"
      @update:snackbar="(val) => {snackbar = val}"
      @update:confirmationDialog="(val) => {confirmationDialog = val}"
      @update:paymentDialog="(val) => {paymentDialog = val}"
      @selectedMethod="selectedMethod"
      @selectPayment="confirmPayment"
      @clear="clear"
    />

    <v-snackbar
      v-model="wasCopied"
      color="green"
    >
      <p style="margin: 0 auto">Скопировано!</p>
    </v-snackbar>
  </div>
</template>

<script>
import PaymentItem from './PaymentItem'
import { getTransactions, updateStatus } from '../../../../../api/transactions'
import PaginatedTable from '@/components/PaginatedTable.vue'
import PayoutsMethodsModal from '@/components/modals/PayoutsMethodsModal.vue'

export default {
  name: 'PaymentsTable',
  components: {
    PayoutsMethodsModal, PaginatedTable, PaymentItem
  },
  data () {
    return {
      search: '',
      transactionId: '',
      outerTransactionId: '',
      page: 1,
      SELECTED_ITEM_STATUS: {
        0: 'В обработке',
        1: 'Отказано',
        2: 'Принято',
        4: 'Запрос отправлен',
        9: 'На бэке'
      },
      currentStatusFilter: null,
      wasCopied: false,
      dropdownItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'В обработке',
          value: 0
        },
        {
          title: 'Отказано',
          value: 1
        },
        {
          title: 'Принято',
          value: 2
        },
        {
          title: 'Запрос отправлен',
          value: 4
        },
        {
          title: 'На бэке',
          value: 9
        }
      ],
      paymentDialog: false,
      isDisabled: false,
      paymentSystem: null,
      confirmationDialog: false,
      pagination: {
        sortBy: 'created_at',
        descending: true
      },
      loading: true,
      selectedPaymentMethod: null,
      headers: [
        { text: '', value: '' },
        { text: 'Дата и время', value: 'created_at' },
        { text: 'User ID', value: 'user_id' },
        { text: 'Ник', value: 'user.name' },
        { text: 'Подтвержден', value: 'user.verification_status' },
        { text: 'Метод', value: 'method' },
        { text: 'Платежная система', value: 'payway' },
        { text: 'Банк', value: 'bank_name' },
        { text: 'Номер карты/кошелька', value: 'bill' },
        { text: 'Сумма', value: 'amount' },
        { text: 'ID операции', value: 'payment_transaction_id' },
        { text: 'Внешний ID операции', value: 'outer_transaction_id' },
        { text: 'Статус', value: 'status' },
        { text: 'Ник администратора', value: 'admin.name' },
        { text: 'Wager', value: 'user.wager' },
        { text: 'Trust point', value: 'trust_point' },
        { text: '', value: 'other' }
      ],
      selected: [],
      switchBox: false,
      items: [],
      snackbar: false,
      snackbarText: null
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    search () {
      this.pullFunction(this.page)
      this.$refs.table?.resetPagination()
    },
    transactionId () {
      this.pullFunction(this.page)
      this.$refs.table?.resetPagination()
    },
    outerTransactionId () {
      this.pullFunction(this.page)
      this.$refs.table?.resetPagination()
    },
    selected (newValue) {
      if (newValue.length === 0)
        this.pullFunction(this.page)
    },
    currentStatusFilter () {
      this.pagination.page = 1
      this.$refs.table.$refs.pagination.page = 1
      this.$refs.table.$refs.pagination.pages = 1
      this.pullFunction(1)
    }
  },
  created () {
    this.pullFunction(this.page)
  },
  methods: {
    selectModal () {
      this.paymentDialog = true
      this.selected.forEach(item => {
        if (item.method === 'piastrix') {
          this.paymentSystem = 'piastrix'
          this.confirmationDialog = true
          this.paymentDialog = false
        }
        if (item.method === 'freekassa' || item.method === 'fk_wallet') {
          this.paymentSystem = 'fk_wallet'
          this.confirmationDialog = true
          this.paymentDialog = false
        }
        if (item?.payway && item?.payway.startsWith('exnode')) {
          this.paymentSystem = 'exnode'
          this.confirmationDialog = true
          this.paymentDialog = false
        }
      })
    },
    selectedMethod (method) {
      this.paymentSystem = method
      this.paymentDialog = false
      this.confirmationDialog = true
    },
    confirmPayment () {
      this.isDisabled = true
      const ids = this.selected.map(item => item.id)
      updateStatus({
        payment_system: this.paymentSystem,
        transaction_ids: ids
      }).then(res => {
        const hasError = res.data.some(item => item.error_message)
        if (hasError) {
          this.snackbarText = 'Ошибка'
          this.snackbar = true
          return
        }

        this.snackbarText = 'Успешно'
        this.snackbar = true
        this.switchBox = true
        this.selected.forEach(item => {
          item.status = res.data[0].status
          item.statusString = this.SELECTED_ITEM_STATUS[item.status]
        })
        this.pullFunction(this.page)
      })
        .catch(err => {
          this.snackbarText = `Ошибка: ${err.response.status} ${err.response.data.message}`
          this.snackbar = true
        })
        .finally(() => {
          this.clear()
          this.selectedPaymentMethod = null
          this.selected = []
        })
    },
    confirm (status) {
      const ids = this.selected.map(item => item.id)
      updateStatus({
        status,
        transaction_ids: ids
      }).then(response => {
        if (response.error_message) {
          this.snackbarText = response.error_message
          this.snackbar = true
          return
        }

        this.switchBox = true
        this.selected.forEach(item => {
          item.status = response.data.status
          item.statusString = this.SELECTED_ITEM_STATUS[item.status]
        })
        this.pullFunction(this.page)
      })

      this.clear()
      this.selectedPaymentMethod = null
      this.selected = []
    },
    totalAmount () {
      if (this.selected.length !== 0)
        return this.selected.reduce((accumulator, currentItem) => accumulator + currentItem.amount, 0)
    },
    handleItemSelected (selectedItem) {
      if (!this.selectedPaymentMethod)
        this.selectedPaymentMethod = selectedItem.item.method

      if (selectedItem.selected === true) {
        this.selected.push(selectedItem.item)
      } else {
        const index = this.selected.findIndex(item => item === selectedItem.item)
        this.selected.splice(index, 1)
      }

      if (this.selected.length === 0)
        this.selectedPaymentMethod = null
    },
    pullFunction (page) {
      this.page = page
      getTransactions({
        limit: 26,
        offset: (page - 1) * 25,
        sort: 'created_at:desc',
        operation: 'Вывод',
        status: this.currentStatusFilter,
        bill: this.search,
        outer_transaction_id: this.outerTransactionId,
        payment_transaction_id: this.transactionId,
        with_withdrawal_request_status: 1,
        // with_wager: 1,
        with_trust_point: 1,
        only_payment_methods: 1
      }).then(response => {
        this.items = response.data
        this.items.forEach(item => {
          item.statusString = this.SELECTED_ITEM_STATUS[item.status]
        })
        this.loading = false
      })
    },
    clear () {
      this.isDisabled = false
      this.confirmationDialog = false
      this.paymentSystem = null
      this.switchBox = false
    }
  }
}
</script>

<style scoped>
.search-input {
  width: 30%;
  margin-left: auto;
  margin-bottom: 10px;
}

.filter-wrap{
  display:flex;
  flex-direction: column;
  align-items: flex-end;

  p{
    margin: 0;
  }
  .filter{
    width: 30%;
  }
}
</style>
